








import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({
  components: {
    PageHeading,
  },
})
export default class PageHeading extends Vue {
  @Prop({default: 'h2', required: false}) private customClass!: string;
  @Prop({default: 'h1', required: false}) private element!: string;
}
